<template>
  <vs-card>
    <ListLeadsB2C />
  </vs-card>
</template>
<script>
import ListLeadsB2C from './Leads/ListLeadsB2C.vue';

export default {
  components: {
    ListLeadsB2C,
  },
};
</script>
